import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=04437488&scoped=true&"
import script from "./Languages.vue?vue&type=script&lang=js&"
export * from "./Languages.vue?vue&type=script&lang=js&"
import style0 from "./Languages.vue?vue&type=style&index=0&id=04437488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04437488",
  null
  
)

export default component.exports